const lineHeightDiffernceFactor = 113;

export const validateLineHeight = (value: number): number => {
  return value / lineHeightDiffernceFactor;
};

export const getFontFamilyWithVariation = (model: any, isStyleForSecondFont: boolean = false) => {
  const fontFamily = isStyleForSecondFont ? model.fontFamily2 : model.fontFamily;
    const font = window.postermywall.core.model.AppProxy.FONTS_MAP[fontFamily];
    const variationApplied: any = {};
    const isBold = isStyleForSecondFont ? model.isBold2 : model.isBold;
    const isItalic = isStyleForSecondFont ? model.isItalic2 : model.isItalic;
    let updatedFontFamily = fontFamily;
    let variation;

  // new window.postermywall.core.model.vo.GraphicItemVectorVO();

  variation =
    isItalic && isBold
      ? window.postermywall.core.model.vo.GraphicItemVO.BOLD_ITALIC_VARIATION
      : isItalic
        ? window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION
        : isBold
          ? window.postermywall.core.model.vo.GraphicItemVO.BOLD_VARIATION
          : '';
  variationApplied[window.postermywall.core.model.GraphicItemVO.BOLD_VARIATION] = false;
  variationApplied[window.postermywall.core.model.GraphicItemVO.ITALIC_VARIATION] = false;

  if (font && font.variation.length && font.variation.includes(variation)) {
    updatedFontFamily = `${fontFamily  }_${  variation}`;
    if (variation === window.postermywall.core.model.vo.GraphicItemVO.BOLD_ITALIC_VARIATION) {
      variationApplied[window.postermywall.core.model.vo.GraphicItemVO.BOLD_VARIATION] = true;
      variationApplied[window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION] = true;
    } else {
      variationApplied[variation] = true;
    }
  }

  if (fontFamily === updatedFontFamily) {
    if (font && font.variation.length && font.variation.includes(window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION) && isItalic) {
      updatedFontFamily = `${fontFamily  }_${  window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION}`;
      variationApplied[window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION] = true;
    }
    if (font && font.variation.length && font.variation.includes(window.postermywall.core.model.vo.GraphicItemVO.BOLD_VARIATION) && isBold) {
      updatedFontFamily = `${fontFamily  }_${  window.postermywall.core.model.vo.GraphicItemVO.BOLD_VARIATION}`;
      variationApplied[window.postermywall.core.model.vo.GraphicItemVO.ITALIC_VARIATION] = false;
      variationApplied[window.postermywall.core.model.vo.GraphicItemVO.BOLD_VARIATION] = true;
    }
  }
  return {fontFamily: updatedFontFamily, variationApplied};
};
